import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver loop warnings (commonly fired by Radix UI / Recharts)
// so they don't trigger the CRA dev error overlay and block interactions.
// Use capture phase so this runs before webpack-dev-server's overlay error listener.
const isROLoop = (msg) => typeof msg === "string" && msg.includes("ResizeObserver loop");
window.addEventListener("error", (e) => {
  if (isROLoop(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
}, true);
window.addEventListener("unhandledrejection", (e) => {
  if (isROLoop(e.reason?.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
